import { Controller } from 'stimulus'

export default class extends Controller {
  toggle(_e) {
    this.element.classList.toggle('open')
  }

  connect() {
    document.addEventListener('click', () => this.element.classList.remove('open'))
    this.element.addEventListener('click', e => e.stopPropagation())
  }
}
